import { Swiper, SwiperSlide, SwiperRef } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { useEffect, useRef } from 'react';
import 'swiper/css';
import 'swiper/css/navigation';

export default function PropertyResult({ property, isActive }) {

    const swiperRef = useRef(null);

    useEffect(() => {
        if (swiperRef.current) {
            swiperRef.current.swiper.params.loop = swiperRef.current.swiper.slides.length > 1;
        }
    }, []);

    function swiperSlides(images) {
        return images != null && images.map((x, i) =>
            <SwiperSlide key={i}>
                <div className="relative">
                    <img src={x.Url} alt={x.Alt} className="h-100"
                        sizes="(min-width: 799px) 800px, (min-width: 1100px) 1100px, (min-width: 1800px) 1400px"
                        srcSet={x.RawUrl + "?width=800&height=600 800w, " + x.RawUrl + "?width=600&height=400 1100w, " + x.RawUrl + "?width=500&height=500 1400w"} />
                </div>
            </SwiperSlide>
        );
    }


    return (
        <div id={'p_' + property.Id} key={property.Id } className="prop-cell cell small-12 medium-6">
            <div className={'property-result grid-x has-faux-link' + (isActive ? ' active' : '')}>
                <div className="cell medium-12 large-6 p-images">
                    {property.PropertyImages != null && 
                        <Swiper ref={swiperRef} modules={[Navigation]} slidesPerView={1} spaceBetween={8} loop={false} navigation={{ nextEl: '.next', prevEl: '.prev' }}>
                            {property.PropertyImages.length > 1 &&
                                <>
                                    <button type="button" className="prev absolute circle-arrow left">
                                        <span className="show-for-sr">previous image</span>
                                        <svg className="@chevronclasses rotate-90">
                                            <use href="#chevron"></use>
                                        </svg>
                                    </button>
                                    <button type="button" className="next absolute circle-arrow right">
                                        <span className="show-for-sr">next image</span>
                                        <svg className="@chevronclasses -rotate-90">
                                            <use href="#chevron"></use>
                                        </svg>
                                    </button>
                                </>
                            }
                            {swiperSlides(property.PropertyImages)}
                            <a href={property.Url} className="faux-link show-for-medium z-1">
                                <span className="faux-link-text">{property.SubHeading} {property.Body}</span>
                            </a>
                        </Swiper>
                    }

                    {property.Status &&
                        <div className={"absolute status " + (property.Status == " Coming soon" ? "bg-lightblue" : "bg-darkblue")}>{property.Status}</div>
                    }
                    {property.ShowHeartIcon && false &&
                        <my-bidwells data-property-reference={property.PropertyReference.ID}>
                            <button type="button" className="z-2 w-10 h-10 block text-zodiacblue bg-blizzard absolute top-5 right-5 flex items-center justify-center" is="my-bidwells-toggle">
                                <svg class="block w-5 h-5">
                                    <use href="heart"></use>
                                </svg>
                            </button>
                        </my-bidwells>
                    }
                    
                </div>               

                <div className="cell medium-12 large-6 has-faux-link p-2">
                    {renderPropertyDetails(property)}

                    <a href={property.Url} className="faux-link">
                        <span className="faux-link-text">{property.SubHeading + ' ' + property.Body}</span>
                    </a>
                </div>
            </div>
        </div>
    );

    function renderPropertyDetails(property) {
        //0 Residential,
        //1 Commercial,
        //2 Rural,
        //3 BNG
        //4 Carbon Credit
        //5 Investment

        switch (property.CardType) {
            case 0:
                return (
                    <>
                        <h4 className="property-heading">{property.Heading}</h4>
                        <p className="property-address">{property.SubHeading}</p>
                        <p className="mt-3">{property.Body}</p>
                        <div className="mt-auto">
                            <div className="flex-container align-justify mt-3">
                                <span className="eyebrow">{property.Footer}</span>
                                <div className="card-icons flex-container align-bottom ml-2">
                                    {property.Bedrooms > 0 &&
                                        <div className="flex-container align-end">
                                            <svg className="icon mr-1">
                                                <use href="#bedroom"></use>
                                            </svg>
                                            <span className="text-property-icon">{property.Bedrooms}</span>
                                        </div>
                                    }
                                    {property.Bathrooms > 0 &&
                                        <div className="flex-container align-end ml-2">
                                            <svg className="icon mr-1">
                                                <use href="#bathroom"></use>
                                            </svg>
                                            <span className="text-property-icon">{property.Bathrooms}</span>
                                        </div>
                                    }
                                    {property.ReceptionRooms > 0 &&
                                        <div className="flex-container align-end ml-2">
                                            <svg className="icon mr-1">
                                                <use href="#reception"></use>
                                            </svg>
                                            <span className="text-property-icon">{property.ReceptionRooms}</span>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </>
                )
            case 1:
                return (
                    <>
                        <h4 className="property-heading">{property.Heading}</h4>
                        <p className="icon property-address">{property.Address}</p>
                        {property.Price && <p className="icon property-price">{property.Price}</p>}
                        {property.Size && <p className="icon property-size">{property.Size}</p>}
                        {property.PropertyType && <p className="icon property-types">{property.PropertyType}</p>}
                        <hr />
                        {property.Agent1 &&
                            <div className="property-agent">
                                <img src="/v2/icons/agent.png" height="27" width="27" alt={property.Agent1} />
                                <span>{property.Agent1}</span>
                            </div>
                        }
                        {property.Agent2 &&
                            <div className="property-agent">
                                <img src="/v2/icons/agent.png" height="27" width="27" alt={property.Agent2} />
                                <span>{property.Agent2}</span>
                            </div>
                        }
                    </>
                );
            case 2:
                return (
                    <>
                        <h4 className="property-heading">{property.Heading}</h4>
                        <p className="icon property-address">{property.Address}</p>
                        {property.Price && <p className="icon property-price">{property.Price}</p>}
                        {property.Size && <p className="icon property-size">{property.Size}</p>}
                        <hr />
                        {property.Agent1 &&
                            <div className="property-agent">
                                <img src="/v2/icons/agent.png" height="27" width="27" alt={property.Agent1} />
                                <span>{property.Agent1}</span>
                            </div>
                        }
                        {property.Agent2 &&
                            <div className="property-agent">
                                <img src="/v2/icons/agent.png" height="27" width="27" alt={property.Agent2} />
                                <span>{property.Agent2}</span>
                            </div>
                        }
                    </>
                );
            case 3:
                return (
                    <>
                        <h4 className="property-heading">{property.Heading}</h4>
                        <p className="icon property-address">{property.Address}</p>
                        {property.Price && <p className="icon property-price">{property.Price}</p>}
                        <p className="icon property-lpnc">{property.LpNc}</p>
                        {property.PropertyType && <p className="icon property-types">{property.PropertyType}</p>}
                        
                        {property.Agent1 &&
                            <>
                            <hr />
                            <div className="property-agent">
                                <img src="/v2/icons/agent.png" height="27" width="27" alt={property.Agent1} />
                                <span>{property.Agent1}</span>
                            </div>
                            </>
                        }
                        {property.Agent2 &&
                            <div className="property-agent">
                                <img src="/v2/icons/agent.png" height="27" width="27" alt={property.Agent2} />
                                <span>{property.Agent2}</span>
                            </div>
                        }
                    </>
                );
            case 4:
                return (
                    <>
                        <h4 className="property-heading">{property.Heading}</h4>
                        <p className="icon property-address">{property.Address}</p>
                        {property.Price && <p className="icon property-price">{property.Price}</p>}
                        {property.UnitCount && <p className="icon property-size">{property.UnitCount} Units available</p>}
                        <p className="icon vintage-years">{property.VintageYears}</p>

                        {property.Agent1 &&
                            <>
                                <hr />
                                <div className="property-agent">
                                    <img src="/v2/icons/agent.png" height="27" width="27" alt={property.Agent1} />
                                    <span>{property.Agent1}</span>
                                </div>
                            </>
                        }
                        {property.Agent2 &&
                            <div className="property-agent">
                                <img src="/v2/icons/agent.png" height="27" width="27" alt={property.Agent2} />
                                <span>{property.Agent2}</span>
                            </div>
                        }
                    </>
                );
            case 5:
                return (
                    <>
                        <h4 className="property-heading">{property.Heading}</h4>
                        <p className="icon property-address">{property.Address}</p>
                        {property.Size && <p className="icon property-size">{property.Size}</p>}
                        {property.PropertyType && <p className="icon property-types">{property.PropertyType}</p>}
                        <hr />
                        {property.Agent1 &&
                            <div className="property-agent">
                                <img src="/v2/icons/agent.png" height="27" width="27" alt={property.Agent1} />
                                <span>{property.Agent1}</span>
                            </div>
                        }
                        {property.Agent2 &&
                            <div className="property-agent">
                                <img src="/v2/icons/agent.png" height="27" width="27" alt={property.Agent2} />
                                <span>{property.Agent2}</span>
                            </div>
                        }
                    </>
                );
        }
    }
}